/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointIcon20Solid = forwardRef('HandPointIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 11.25V3.5a2 2 0 1 1 4 0v3.8l4.368.749a2.5 2.5 0 0 1 2.009 3.047l-1.317 5.487a2.5 2.5 0 0 1-2.43 1.917H8.981a2.5 2.5 0 0 1-1.701-.668l-4.812-4.468a1.931 1.931 0 0 1 2.09-3.184L7 11.25Z" })));
});
